import request from '../request';

export const saveContentToLibrary = (data = {}) =>
  request.post('library/content', data).then((res) => res);

export const getContent = (type = '', timestamp = '') =>
  request
    .get(`library/service/?${type && `type=${type}&`}timestamp=${timestamp}`)
    .then((res) => res);

export const getContentByFF = (
  /** @type {boolean} */ ShowServiceLibrary,
  type = '',
  timestamp = ''
) => {
  const params = new URLSearchParams({ timestamp });
  if (ShowServiceLibrary && type) params.set('type', type);
  const url = ShowServiceLibrary
    ? 'library/service/'
    : `library/content/${type ? encodeURIComponent(type) : ''}`;
  return request.get(`${url}?${params.toString()}`).then((res) => res);
};

export const updateContent = (contentid = '', data = {}) =>
  request.put(`library/content/${contentid}`, data).then((res) => res);

export const deleteContent = (contentid = '') =>
  request.delete(`library/content/${contentid}`).then((res) => res);
